<template>
    <div>
     <b-modal size="xl" :id="ModalId" 
      :modal-class="'is-draggable'"
     @shown="prepararDrag"
     :visible="true" centered no-close-on-backdrop no-close-on-esc
      :title="TitleWindow" ref="modalEditGoals" @close="this.emitEventCancel" 
      @ok="handleOk" :ok-title="$t('Shared.Save')"  @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')"> 

      <form ref="form_GoalEdit" @submit.stop.prevent="handleSubmit">
        <b-row>
        <b-col md="12">
          <div class="textlabel" :data-label="$t('Shared.Description')"></div>
              <MdMemo v-bind:Name="'goaldescription'" v-bind:Rows="'4'" v-bind:UseDinamicClass="true"
                v-bind:DynamicClass="'modalTextarea ml-2'" v-bind:MaxRows="'6'"
                v-model="GoalEdit.description" />
        </b-col>
        </b-row>
        <b-row>
            <b-col md="3">
              <MdEdit 
                v-bind:Label="$t('modalEditGoal.dIdentified')" v-bind:Name="'dateidentified'" v-bind:TypeProp="'text'"
                v-bind:Mask="'##/##/#### ##:## AA'" v-bind:Min="'1900-01-01'" v-bind:Max="'2200-12-31'"            
                v-model="GoalEdit.dateIdentified" v-bind:Id="'input_dateidentified_id'"/>   
            </b-col>
            <b-col md="3">
              <MdEdit 
                v-bind:Label="$t('modalEditGoal.eDate')" v-bind:Name="'ExpectedDate'" v-bind:TypeProp="'text'"                 
                v-bind:Mask="'##/##/#### ##:## AA'" v-bind:Min="'1900-01-01'" v-bind:Max="'2200-12-31'"            
                v-model="GoalEdit.dateExpected" v-bind:Id="'input_ExpectedDate_id'"/>   
            </b-col>
            <b-col md="3">
              <MdEdit 
                v-bind:Label="$t('modalEditGoal.aDate')" v-bind:Name="'AchievedDate'" v-bind:TypeProp="'text'"                 
                v-bind:Mask="'##/##/#### ##:## AA'" v-bind:Min="'1900-01-01'" v-bind:Max="'2200-12-31'"            
                v-model="GoalEdit.dateAchieve" v-bind:Id="'input_AchievedDate_id'"/>   
            </b-col>
            <b-col md="3">
              <MdSelect 
                v-bind:Label="$t('Shared.Status')" v-bind:Options="StatusList" v-bind:FieldDescription="'description'" 
                v-bind:FieldCode="'code'" v-bind:Model="GoalEdit.status" v-bind:Multiple="false" v-bind:AllowEmpty="false"
                :Input="ChangeDropDownStatus" v-bind:Name="'status_select'" :id="'status_select_'" />
            </b-col>
        </b-row>
      </form>
     </b-modal>  
    </div>
</template>
 
 <script>
 import Utils from '@/common/utils'
 import moment from 'moment'
 import ShowMessage from '@/components/messages/ShowMessage.js'
 import TreatmentPlan from '@/services/treatmentplan.service'
 

 export default {
   name: 'ModalEditGoal',
   mixins: [ShowMessage],  
   props: {
     ModalId: String,
     TitleWindow: String,
     ProblemRecId:String,
     groupId:Number,
     headerId:String,
     probCode:String,
     GoalEdit:Object
   },
   
   data(){
     return {
        goaldescriptionBlank:"",
        DateFrom:null,
        GoalsList:[],
        GoalsModel:[],
        StatusList: [
                { code: "INPROGRESS", description: this.$t('modalEditGoal.INPROGRESS') },
                { code: "MET", description: this.$t('modalEditGoal.MET') },
                { code: "UNMET", description: this.$t('modalEditGoal.UNMET') },
                { code: "REVISED", description: this.$t('modalEditGoal.REVISED') },
                { code: "EXTENDED", description: this.$t('modalEditGoal.EXTENDED') },
                { code: "DEFERRED", description: this.$t('modalEditGoal.DEFERRED') },
                { code: "REFERRED", description: this.$t('modalEditGoal.REFERRED') }
            ],
     }
   },
 
   methods:{
     prepararDrag() {
  this.$nextTick(() => {
    const outer = document.getElementById(`${this.ModalId}___BV_modal_outer_`);
    if (!outer) {
      console.warn("No se encontró el contenedor del modal");
      return;
    }

    const dialog = outer.querySelector(".modal-dialog");
    const header = outer.querySelector(".modal-header");

    if (!dialog || !header) {
      console.warn("No se encontró header o dialog");
      return;
    }

    if (outer.classList.contains("is-draggable")) 
            return;

    header.style.cursor = "move";

    header.onmousedown = (e) => {
      e.preventDefault();

      // Obtener posición actual antes de tocar estilos
      const rect = dialog.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      // Fijar posición actual (solo en el primer movimiento)
      dialog.style.width = `${rect.width}px`;
      dialog.style.height = `${rect.height}px`;
      dialog.style.position = "fixed";
      dialog.style.left = `${rect.left}px`;
      dialog.style.top = `${rect.top}px`;
      dialog.style.margin = 0;
      dialog.style.transform = "none";

      const moveHandler = (eMove) => {
        dialog.style.left = `${eMove.clientX - offsetX}px`;
        dialog.style.top = `${eMove.clientY - offsetY}px`;
      };

      document.addEventListener("mousemove", moveHandler);
      document.addEventListener(
        "mouseup",
        () => document.removeEventListener("mousemove", moveHandler),
        { once: true }
      );
    };
  });
},
     emitEventOK(/*bvModalEvent*/){
      if(Utils.isValidDate(this.GoalEdit.dateAchieve, Utils.getDateTimeFormat()) || this.GoalEdit.dateAchieve === "" || this.GoalEdit.dateAchieve === null){
        this.UpdateGoal();    
      }else{
        this.showMessage(this.$tc('Msg.Error'),this.$t('modalEditGoal.iArchiveMsg'),"error");
      }
     },

     validDI(){
       if(this.GoalEdit.dateIdentified !== "" && this.GoalEdit.dateIdentified !== null && !Utils.IsValidDateAndRange(this.GoalEdit.dateIdentified, Utils.getDateTimeFormat())){
        this.showMessage(this.$tc('Msg.Error'),this.$t('modalEditGoal.inIdentifiedMsg'),"error");
        return false;
       }
       return true;
      },

      validDE(){
       if(this.GoalEdit.dateExpected !== "" && this.GoalEdit.dateExpected !== null && !Utils.IsValidDateAndRange(this.GoalEdit.dateExpected, Utils.getDateTimeFormat())){
        this.showMessage(this.$tc('Msg.Error'),this.$t('modalEditGoal.iExpectedMsg'),"error");
        return false;
       }
       return true;
      },

     checkFormValidity() {
      if(this.GoalEdit.dateIdentified !== '' && this.GoalEdit.dateExpected !== '' && this.GoalEdit.dateIdentified !== null && this.GoalEdit.dateExpected !== null){
        let DI = moment(this.GoalEdit.dateIdentified, Utils.getDateTimeFormat());
        let DE = moment(this.GoalEdit.dateExpected, Utils.getDateTimeFormat());       
        if(DI > DE){	        
         return false;       
				}else{
          return true;
        }
      }else{
        return true;
      }      
      },

     handleOk(bvModalEvt) {      
        bvModalEvt.preventDefault();      
        this.handleSubmit()
      },

      handleSubmit() { 
      if(!this.checkFormValidity()){
        this.showMessage(this.$tc('Msg.Error'),this.$t('modalEditGoal.dIdentifiedMsg'),"error")
      }else{
        if(this.validDI() && this.validDE()){
          this.emitEventOK();
        }       
      } 
    },

     /* handleSubmit() {       
        !this.checkFormValidity() ? this.showMessage(this.$tc('Msg.Error'),'Date Identified must be greater than Date Expected',"error"):this.emitEventOK();
      },*/

     OnChangeGoals(){

     },

     UpdateGoal(){        
          let data = {
            goalCode: this.GoalEdit.goalCode,
            goalDesc:this.GoalEdit.description,
            dateSet:Utils.formatterToISO(this.GoalEdit.dateIdentified, Utils.getDateTimeFormat()),
            dateExp:Utils.formatterToISO(this.GoalEdit.dateExpected, Utils.getDateTimeFormat()),
            dateAchieve:Utils.formatterToISO(this.GoalEdit.dateAchieve, Utils.getDateTimeFormat()),
            status:this.GoalEdit.status.code
          };
         TreatmentPlan.UpdateGoal(this.GoalEdit.goalRecId,data)
            .then((response) => { 
               if(response.data){
                this.$emit('RefreshGetTP');
                setTimeout(() => 
                        this.$bvToast.toast(this.$t('treatmentplan.GoalSaved'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 5); 
               }             
            })
            .catch((error) => {
                if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToUpdate'),"error");
                }     
                   else if(error.response.status === 400 ){
                     this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }   
                     else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }    
            });
       
    },

     ChangeDropDownStatus(value){      
      this.GoalEdit.status = value ? value : {code:"",description:""};
     },

     emitEventCancel(){
      this.$emit('ModalTPEditGoal');
    },    
   },
 
   mounted(){
    //await this.getWileyTxGoals();
   },
 };
 </script> 
 <style>


.modal-dialog {
  transition: none !important;
  transform: none !important;
}

.modal-dialog.dragging {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  opacity: 0.98;
  cursor: grabbing !important;
  transition: box-shadow 0.2s ease;
}
.modal-header {
  user-select: none; /* evita seleccionar texto al arrastrar */
}
</style>